export default "__VITE_ASSET__DPB4Wony__"